<template>
  <div class="page pt-5">
    <div class="page__wrapper">
      <app-loader v-if="loader" />
      <template v-else>
        <h3 class="mb-3">
          {{ pageTitle }}
        </h3>
        <v-card
          v-for="it in receptionZones"
          :key="it.id"
          :to="{
            name: 'CarsByZone',
            params: {
              id: it.id,
              type,
            }
          }"
          elevation="1"
          color="yellow lighten-4"
          class="card-custom"
          ripple
        >
          <v-card-text>
            {{ it.description }}:
            <b>{{ it.amount }}</b>
          </v-card-text>
        </v-card>
      </template>
    </div>
    <div class="page__actions justify-start">
      <v-btn
        color="error lighten-1"
        x-large
        @click="$router.push('/navigation')"
      >
        Назад
      </v-btn>
      <v-btn
        class="mx-1"
        color="primary"
        x-large
        @click="$router.push('/navigation')"
      >
        <v-icon>mdi-home</v-icon>
      </v-btn>
    </div>
    <result-modal
      v-model="errorModal"
      :title="errorText"
    />
  </div>
</template>

<script>
import ResultModal from '@/components/ResultModal.vue';

export default {
  name: 'Reception',
  components: {
    ResultModal,
  },
  props: {
    type: String,
  },
  data: () => ({
    loader: false,
    receptionZones: [],
    errorModal: false,
    errorText: '',
  }),
  computed: {
    pageTitle() {
      return this.$route.path.includes('acceptance') ? 'Приемка' : 'Возврат';
    },
  },
  created() {
    this.getReceptionZones();
  },
  methods: {
    async getReceptionZones() {
      this.loader = true;
      let url = 'MobileOperatorInterface/Reception/ReceptionZones';
      if (this.type === 'return') {
        url = 'MobileOperatorInterface/Return/ReturnZones';
      }
      const { data } = await this.$http.get(url).catch((e) => {
        this.onErrorHandler(e);
      }).finally(() => {
        this.loader = false;
      });
      this.receptionZones = data;
    },
    onErrorHandler(e) {
      this.errorModal = true;
      this.errorText = e?.response?.data?.errorMess || 'Ошибка сервера';
    },
  },
};
</script>

<style>

</style>
